import React, { useState } from 'react'
import signInLogo from '../assets/img/signIn.png';
import {AiFillEyeInvisible,AiFillEye} from "react-icons/ai"
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { toast } from 'react-toastify';
import "../css/Login.css";

const Login = () => {
  const [showPassword,setShowPassword]=useState(false)
  const [formData,setFormData]=useState({
    email:"",
    password:""
  });

  const {email,password}=formData

  const navigate=useNavigate()

  function onChange(e){
    setFormData((pre)=>({
      ...pre,
      [e.target.id]:e.target.value
    }))
  }
  async function onSubmit(e){
    e.preventDefault()
    try {
      const auth=getAuth()
      const userCredential=await signInWithEmailAndPassword(auth,email,password)
      toast.success("correct")
      //console.error("ok");
      if(userCredential.user){
        navigate("/admin")
      }

    } catch (error) {
      toast.error("user credentials are wrong")
      console.error("Error signing in", error);
    }
  }


  return (
    <section style={{backgroundColor:"#121212",marginTop:"0"}}>

            <div className='login-container' style={{marginTop:"80px"}}>
                <div className='image-wrapper'>
                  
                    <img src={signInLogo} alt="SignIn" className='signin-image'  />
                </div>
                <div className='form-wrapper'>
                <h1 style={{color:"orange",fontWeight:"900",textAlign:"center",marginBottom:"40px"}}>Login</h1>
                    <form onSubmit={onSubmit}>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={onChange}
                            placeholder='Email Address'
                            className='input-field'
                        />
                        <div className='password-container'>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={onChange}
                                placeholder='Password'
                                className='input-field'
                            />
                            {showPassword ? (
                                <AiFillEyeInvisible
                                    className='password-toggle'
                                    onClick={() => setShowPassword((prev) => !prev)}
                                />
                            ) : (
                                <AiFillEye
                                    className='password-toggle'
                                    onClick={() => setShowPassword((prev) => !prev)}
                                />
                            )}
                        </div>
                        <div className='options'>
                            <p>
                                <Link to="/forgot-password" className='link'>Forget Password</Link>
                            </p>
                        </div>
                        <button type='submit' className='submit-button' style={{paddingBottom:"15px",paddingTop:"15px"}}>Sign In</button>
                    </form>
                </div>
            </div>
        </section>
  )
}

export default Login